import React, { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

function formatDetail(d) {
  if (!d) return "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e.msg || JSON.stringify(e)).join(" ");
  return String(d);
}

export default function AdminLogin() {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  React.useEffect(() => {
    if (user) nav("/admin", { replace: true });
  }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await login(email, password);
      toast.success("Signed in");
      const to = loc.state?.from || "/admin";
      nav(to, { replace: true });
    } catch (e) {
      setErr(formatDetail(e.response?.data?.detail) || e.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: "var(--bp-bg)" }}>
      <div className="w-full max-w-md p-8 bg-white border" style={{ borderColor: "var(--bp-border)" }}>
        <Link to="/" className="font-serif text-2xl" data-testid="login-logo">BrandPassport</Link>
        <div className="uppercase text-xs tracking-widest mt-1" style={{ color: "var(--bp-text-muted)" }}>Editor console — sign in</div>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <label className="text-xs uppercase tracking-widest">Email</label>
            <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest">Password</label>
            <Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" />
          </div>
          {err && <p className="text-sm text-red-700" data-testid="login-error">{err}</p>}
          <Button type="submit" disabled={busy} className="rounded-none w-full" data-testid="login-submit">{busy ? "Signing in…" : "Sign in"}</Button>
        </form>
      </div>
    </div>
  );
}
